import * as yup from "yup";

import { apiSafraLink } from "services/api";
import {
  getToken,
  getTokenIdentifier,
  getTokenUser,
  Logout,
} from "services/auth";

export async function GetUserInfo(token, identifier, user) {
  try {
    const rule = yup.string().min(1);
    const ruleArray = yup.array();

    if ((await rule.isValid(token)) === false) return null;
    if ((await rule.isValid(identifier)) === false) return null;
    if ((await rule.isValid(user)) === false) return null;

    const endpoint = `/home/userinfo?idtUser=${user}`;

    const response = await apiSafraLink
      .get(endpoint, {
        headers: {
          Identificador: identifier,
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .catch((error) => {});

    if (response === undefined || response === null) return null;

    if (response.data === undefined || response.data === null) return null;

    if (response.data.Return === undefined || response.data.Return === null)
      return null;

    localStorage.setItem(
      "@CANS-Data-ProfileReadOnly",
      JSON.stringify(response.data.Return.ProfileReadOnly)
    );

    localStorage.setItem(
      "@CANS-Data-Menu",
      JSON.stringify(response.data.Return.Menus)
    );

    localStorage.setItem(
      "@CANS-Data-Accounts",
      JSON.stringify(response.data.Return.Accounts)
    );

    return response.data.Return;
  } catch (error) {
    return null;
  }
}

export async function GetUserInfoCIF(token, identifier, user) {
  try {
    const rule = yup.string().min(1);
    const ruleArray = yup.array();

    if ((await rule.isValid(token)) === false) return null;
    if ((await rule.isValid(identifier)) === false) return null;
    if ((await rule.isValid(user)) === false) return null;

    const endpoint = `/home/userinfo?idtUser=${user}`;

    const response = await apiSafraLink
      .get(endpoint, {
        headers: {
          Identificador: identifier,
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .catch((error) => {});

    if (response === undefined || response === null) return null;

    if (response.data === undefined || response.data === null) return null;

    if (response.data.Return === undefined || response.data.Return === null)
      return null;

    return response.data.Return.CIFs.map((item) => item.LinkedCIF).sort();
  } catch (error) {
    return null;
  }
}

export function GetAccounts() {
  try {
    const ruleArray = yup.array();
    const accounts = JSON.parse(localStorage.getItem("@CANS-Data-Accounts"));
    const rejectedBranchs= ["203", "204", "205", "206", "207", "208", "209"];

    if (ruleArray.isValidSync(accounts) === true) {
      const filteredAccounts = accounts.filter(item => {
        const accountPrefix = item.Account.substring(0, 3);
        return !rejectedBranchs.includes(accountPrefix);
      });

      const list = filteredAccounts
        .map(item => item.Account)
        .sort()
        .map(item => ({
          value: item,
          label: item,
        }));

      return [{ value: "0", label: "All" }, ...list];
    }

    return [{ value: "0", label: "All" }];
  } catch (error) {
    return [{ value: "0", label: "All" }];
  }
}

export function GetUserMenu() {
  try {
    const endpoint = `/home/userinfo?idtUser=${getTokenUser()}`;

    return apiSafraLink
      .get(endpoint, {
        headers: {
          Identificador: getTokenIdentifier(),
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Logout();

        return false;
      });
  } catch (error) {
    return [];
  }
}
